import { useEffect, useState } from 'react'
import { metricsApi } from 'api'

export const useKpisView = () => {
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(true)
    metricsApi.getKpisPanels().then(response => {
      setItems(response.data)
    }).catch(error => {
      console.error('error: ', error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])
  return {
    items,
    isLoading,
  }
}

export default useKpisView